import type { ComponentMode, FileOwnerType, User } from 'types';

interface State extends User {
  mode: ComponentMode;
  ownerType: FileOwnerType;
  defaultName: string;
  defaultRoleName: string;
}
const initialState: Partial<State> = {};

type Action =
  | {
      type: 'UPDATE_USER_AVATAR';
      payload: Pick<typeof initialState, 'avatarId'>;
    }
  | {
      type: 'UPDATE_USER_FIRST_NAME';
      payload: Pick<typeof initialState, 'firstName'>;
    }
  | {
      type: 'UPDATE_USER_DISPLAY_NAME';
      payload: Pick<typeof initialState, 'displayName'>;
    }
  | undefined;
const initialAction: Action = undefined;

export { initialAction, initialState };
